<template>
  <EmailComponentsEmailAddrPercent />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
